import React from "react";
import styled from "styled-components";
import { UI_CAPTION_DF, colors2 } from "oolib";
import { ButtonGhost } from "oolib/dist/v2/components/Buttons/index.js";
import { Anchor } from "@phosphor-icons/react";

/**
 * "Anchored to <topic>" — shown above the composer while the chat is pinned
 * to a Topics-tab node. The × sends the next message with the anchor cleared;
 * until then every question (typed or chip) stays inside that topic.
 */

const Pill = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.2rem 0.3rem 0.2rem 0.8rem;
  border-radius: 999px;
  background: ${colors2.grey5};
  border: 1px solid ${colors2.grey10};
  margin-bottom: 0.6rem;
`;

export const AnchorPill = ({ anchor, onClear }) => {
  if (!anchor?.nodeId) return null;
  const label = anchor.level === "subTopic" && anchor.topicTitle ? `${anchor.topicTitle} › ${anchor.title}` : anchor.title || "a topic";
  return (
    <Pill>
      <Anchor size={13} color={colors2.grey60} />
      <UI_CAPTION_DF style={{ color: colors2.grey80 }}>
        Anchored to <strong>{label}</strong>
        {anchor.total ? ` · ${anchor.total} observations` : ""}
      </UI_CAPTION_DF>
      {onClear && <ButtonGhost icon="X" S onClick={onClear} />}
    </Pill>
  );
};
